import axiosInstant from "../api";

export type RosterAction = "add" | "remove";

export const changeSelectionRoster = (
    action: RosterAction,
    brandId: number | string,
    projectId: number | string,
    userId: number | string,
    reopenSelection = false
) =>
    action === "add"
        ? axiosInstant.post(
              `/brands/${brandId}/projects/${projectId}/pros`,
              reopenSelection
                  ? { user_ids: userId, reopen_selection: true }
                  : { user_ids: userId }
          )
        : axiosInstant.delete(
              `/brands/${brandId}/projects/${projectId}/pros/${userId}${
                  reopenSelection ? "?reopen_selection=true" : ""
              }`
          );

export const rosterErrorMessage = (error: any): string => {
    if (error?.response?.data?.error === "SelectionAlreadyShot") {
        return "This shoot is already in post-production, so the roster can't change.";
    }
    if (error?.response?.status === 423) {
        return "This selection is locked, roster edits are frozen.";
    }
    return (
        error?.response?.data?.error ||
        "Couldn't update the expert selection. Try again."
    );
};
